
<div class="gcontainer bwhite">
  <div class="mat-table-wrapper no-print">

    <div class="top-bar no-print">
      <table class="project-header">
        <tr>
          <td class="label">Project</td>
          <td class="data">{{ projectName }}</td>
          <td class="label">Reference</td>
          <td class="data">{{ projectReference ?? '' }}</td>
          <td class="label">Company</td>
          <td class="data">{{ companyName }}</td>
          <td class="label">Due Date</td>
          <td class="data">{{ dueDate }}</td>
        </tr>
        <tr>
          <td class="label">Data</td>
          <td class="data rush-cell" colspan="7">
            @if (isRush) {
              <span>RUSH</span>
            }
          </td>
        </tr>
      </table>

      <button
        mat-raised-button
        color="warn"
        class="action-button"
        (click)="printTable()">
        PRINT
      </button>
    </div>

    <table mat-table [dataSource]="dataSource" class="full-width bordered-table">
      <ng-container matColumnDef="inHouseId">
        <th mat-header-cell *matHeaderCellDef>In-House ID</th>
        <td mat-cell *matCellDef="let row">{{ row.inHouseId }}</td>
      </ng-container>

      <!-- 1 -->
      <ng-container matColumnDef="targetMc1">
        <th mat-header-cell *matHeaderCellDef class="group-gray">MC 1</th>
        <td mat-cell *matCellDef="let row" class="group-gray">{{row.targetMc1}}</td>
      </ng-container>

      <ng-container matColumnDef="targetWeight1">
        <th mat-header-cell *matHeaderCellDef class="group-gray">TW 1</th>
        <td mat-cell *matCellDef="let row" class="group-gray">{{row.targetWeight1}}</td>
      </ng-container>

      <ng-container matColumnDef="actualWeight1">
        <th mat-header-cell *matHeaderCellDef class="group-gray">AW 1</th>
        <td mat-cell *matCellDef="let row" class="group-gray">{{row.actualWeight1}}</td>
      </ng-container>

      <!-- 2 -->
      <ng-container matColumnDef="targetMc2">
        <th mat-header-cell *matHeaderCellDef class="group-white">MC 2</th>
        <td mat-cell *matCellDef="let row" class="group-white">{{row.targetMc2}}</td>
      </ng-container>

      <ng-container matColumnDef="targetWeight2">
        <th mat-header-cell *matHeaderCellDef class="group-white">TW 2</th>
        <td mat-cell *matCellDef="let row" class="group-white">{{row.targetWeight2}}</td>
      </ng-container>

      <ng-container matColumnDef="actualWeight2">
        <th mat-header-cell *matHeaderCellDef class="group-white">AW 2</th>
        <td mat-cell *matCellDef="let row" class="group-white">{{row.actualWeight2}}</td>
      </ng-container>

      <!-- 3-->
      <ng-container matColumnDef="targetMc3">
        <th mat-header-cell *matHeaderCellDef class="group-gray">MC 3</th>
        <td mat-cell *matCellDef="let row" class="group-gray">{{row.targetMc3}}</td>
      </ng-container>

      <ng-container matColumnDef="targetWeight3">
        <th mat-header-cell *matHeaderCellDef class="group-gray">TW 3</th>
        <td mat-cell *matCellDef="let row" class="group-gray">{{row.targetWeight3}}</td>
      </ng-container>

      <ng-container matColumnDef="actualWeight3">
        <th mat-header-cell *matHeaderCellDef class="group-gray">AW 3</th>
        <td mat-cell *matCellDef="let row" class="group-gray">{{row.actualWeight3}}</td>
      </ng-container>


      <!-- 4 -->
      <ng-container matColumnDef="targetMc4">
        <th mat-header-cell *matHeaderCellDef class="group-white">MC 4</th>
        <td mat-cell *matCellDef="let row" class="group-white">{{row.targetMc4}}</td>
      </ng-container>

      <ng-container matColumnDef="targetWeight4">
        <th mat-header-cell *matHeaderCellDef class="group-white">TW 4</th>
        <td mat-cell *matCellDef="let row" class="group-white">{{row.targetWeight4}}</td>
      </ng-container>

      <ng-container matColumnDef="actualWeight4">
        <th mat-header-cell *matHeaderCellDef class="group-white">AW 4</th>
        <td mat-cell *matCellDef="let row" class="group-white">{{row.actualWeight4}}</td>
      </ng-container>

      <!-- 5 -->
      <ng-container matColumnDef="targetWeight5">
        <th mat-header-cell *matHeaderCellDef class="group-gray">TW Dry</th>
        <td mat-cell *matCellDef="let row" class="group-gray">{{row.targetWeight5}}</td>
      </ng-container>

      <ng-container matColumnDef="actualWeight5">
        <th mat-header-cell *matHeaderCellDef class="group-gray">AW Dry</th>
        <td mat-cell *matCellDef="let row" class="group-gray">{{row.actualWeight5}}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; let i = index; columns: displayedColumns;"></tr>
    </table>
  </div>

  <div id="print-section">
    <table class="project-header">
      <tr>
        <td class="label">Project</td>
        <td class="data">{{ projectName }}</td>

        <td class="label">Reference</td>
        <td class="data">{{ projectReference ?? '' }}</td>

        <td class="label">Company</td>
        <td class="data">{{ companyName }}</td>

        <td class="label">Due Date</td>
        <td class="data">{{ dueDate }}</td>
      </tr>
      <tr>
        <td class="label">Data</td>
        <td class="data rush-cell" colspan="7">
          @if (isRush) {
            <span>RUSH</span>
          }
        </td>
      </tr>
    </table>

    <table class="print-table">
      <thead>
        <tr>
          <th>In House</th>

          <th>MC 1</th>
          <th>TW 1</th>
          <th>AW 1</th>

          <th>MC 2</th>
          <th>TW 2</th>
          <th>AW 2</th>

          <th>MC 3</th>
          <th>TW 3</th>
          <th>AW 3</th>

          <th>MC 4</th>
          <th>TW 4</th>
          <th>AW 4</th>

          <th>TW Dry</th>
          <th>AW Dry</th>
        </tr>
      </thead>

      <tbody>
        @for (row of dataSource; track row) {
          <tr>
            <td>{{ row.inHouseId }}</td>
            <td>{{ row.targetMc1 }}</td>
            <td>{{ row.targetWeight1 }}</td>
            <td>{{ row.actualWeight1 }}</td>
            <td>{{ row.targetMc2 }}</td>
            <td>{{ row.targetWeight2 }}</td>
            <td>{{ row.actualWeight2 }}</td>
            <td>{{ row.targetMc3 }}</td>
            <td>{{ row.targetWeight3 }}</td>
            <td>{{ row.actualWeight3 }}</td>
            <td>{{ row.targetMc4 }}</td>
            <td>{{ row.targetWeight4 }}</td>
            <td>{{ row.actualWeight4 }}</td>
            <td>{{ row.targetWeight5 }}</td>
            <td>{{ row.actualWeight5 }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>

</div>